import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';


// Components 
import { } from "./Components/ExportComponents";

// Pages 
import { Home, Work, Contact, About, Blog, BlogPreview, PageNotFound } from "./Pages/ExportPages";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/works' element={<Work />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/about' element={<About />} />
        <Route path='/blogs' element={<BlogPreview />} />
        <Route path='/blog/:id' element={<Blog />} />
        <Route path='*' element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
